import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import removeFromArray from '../utils.common/removeFromArray';
import { runCallbacks } from '../utils.common/callbackUtils';
import { GLOBAL_CSS_CLASSES } from '../constants.common/globalCssClasses';

class ScrollService {
    constructor() {
        const queue = [];
        let rafStarted = false;
        let lastScrollPosition;
        let currentScrollPosition;

        this.clearAllBodyScrollLocks = function () {
            clearAllBodyScrollLocks();
        };

        this.disableBodyScroll = function (target) {
            disableBodyScroll(target, {
                allowTouchMove: (el) => {
                    while (el && el !== document.body) {
                        if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                            return true;
                        }

                        el = el.parentElement;
                    }
                },
            });
        };

        this.enableBodyScroll = function (target) {
            enableBodyScroll(target);
        };

        this.add = function (callBack) {
            queue.push(callBack);

            if (window.requestAnimationFrame) {
                if (!rafStarted) {
                    updateScrollPosition();
                }
            }
        };

        this.remove = function (callBack) {
            queue.push(callBack);
            removeFromArray(queue, callBack);
        };

        this.getScrollPosition = function () {
            setCurrentScrollPosition();

            return currentScrollPosition;
        };

        this.saveScrollPosition = function () {
            lastScrollPosition = this.getScrollPosition();
        };

        this.scrollTo = function (position) {
            window.scrollTo({
                top: position,
            });

            setCurrentScrollPosition();
        };

        this.scrollToLastPosition = function () {
            this.scrollTo(lastScrollPosition);
        };

        this.getLastScrollPosition = function () {
            return lastScrollPosition;
        };

        function setCurrentScrollPosition() {
            if (window.pageYOffset) {
                currentScrollPosition = window.pageYOffset;
            } else if (document.documentElement && document.documentElement.scrollTop) {
                currentScrollPosition = document.documentElement.scrollTop;
            } else if (document.body.scrollTop) {
                currentScrollPosition = document.body.scrollTop;
            } else {
                currentScrollPosition = 0;
            }
        }

        function updateScrollPosition() {
            rafStarted = true;

            setCurrentScrollPosition();

            try {
                if (lastScrollPosition !== currentScrollPosition) {
                    if (document.documentElement.classList.contains(GLOBAL_CSS_CLASSES.fixedWindow) === false) {
                        lastScrollPosition = currentScrollPosition;
                        runCallbacks(queue, null);
                    }
                }
            } catch (e) {
                console.warn(e);
            }

            window.requestAnimationFrame(() => updateScrollPosition());
        }
    }
}

const scrollService = new ScrollService();

export default scrollService;
